<template>
<div  style="font-size:14px;    position: relative;" >
<div @click="back" style="position: absolute;right: 30px;  top: 10px; color: #0c46a2;z-index:9999"><i class="fa fa-reply"></i></div>
<el-form :inline="true" ref="goodform" enctype="multipart/form-data" :model="goodform"   class="demo-form-inline"
 size="mini" label-position="left">
  <el-tabs v-model="activeName" >
    <el-tab-pane label="运单详情" name="first">
      <div class="addressBox">
          <h4 class="title">
            <span><i class="fa fa-tags iconFont" aria-hidden="true"></i>单据信息</span>
          </h4>
      </div>
      <el-form-item label="运单编号:"  >
        <div class="width2">{{goodform.wayNo}}</div>
      </el-form-item>
      <el-form-item label="订单编号:"  >
        <div class="width2">{{goodform.orderNo?goodform.orderNo:'-'}}</div>
      </el-form-item>
      <el-form-item label="结算客户:"  >
        <div class="width2">{{goodform.payee}}</div>
      </el-form-item>
      <el-form-item label="销售合同:"  >
        <div class="width2">{{goodform.salesContract?goodform.salesContract:'-'}}</div>
      </el-form-item>
       <el-form-item label="项目名称:"  >
        <div class="width2">{{goodform.projectType?goodform.projectType:'-'}}</div>
      </el-form-item>
      <el-form-item label="业务类型:"  >
        <div class="width2">{{goodform.wayBusinessTypeName?goodform.wayBusinessTypeName:'-'}}</div>
      </el-form-item>
      <el-form-item label="业务部门:"  >
        <div class="width2">{{goodform.businessUnit}}</div>
      </el-form-item>
      <el-form-item label="业务人员:" >
        <div class="width2">{{goodform.businessUser}}</div>
      </el-form-item>
      <hr>
      <div class="addressBox">
          <h4 class="title">
            <span><i class="fa fa-tags iconFont" aria-hidden="true"></i>收发信息</span>
          </h4>
      </div>
      <div>
        <el-form-item    label="发货人:" prop="deliverPerson" v-if="goodform.deliverAddressId">
          <div style="width:80px">{{goodform.deliverPerson}}</div>
        </el-form-item>
        <el-form-item label="电话:" prop="deliverPhone" v-if="goodform.deliverAddressId">
          <div style="width:80px">{{goodform.deliverPhone}}</div>
        </el-form-item>
        <el-form-item   label="始发流向:" v-if="goodform.deliverAddressId">
          <div style="width:200px">{{goodform.startDirection}}</div>
        </el-form-item>
        <el-form-item  label="发货地址:" prop="deliverAddress" class="diqu1" v-if="goodform.deliverAddressId">
          <div style="min-width:150px">{{goodform.deliverAddress}}</div>
        </el-form-item>
      </div>
      <div>
        <el-form-item  label="收货人:" prop="receivingPerson" v-if="goodform.receivingAddressId">
          <div style="width:80px">{{goodform.receivingPerson}}</div>
        </el-form-item>
        <el-form-item label="电话:" prop="receivingPhone" v-if="goodform.receivingAddressId">
          <div style="width:80px">{{goodform.receivingPhone}}</div>
        </el-form-item>
        <el-form-item label="目的流向:" prop="receivingCompany" v-if="goodform.receivingAddressId">
          <div style="width:200px">{{goodform.endDirection}}</div>
        </el-form-item>
        <el-form-item  label="收货地址:" prop="receivingAddress" class="diqu1" v-if="goodform.receivingAddressId">
          <div style="min-width:150px">{{goodform.receivingAddress}}</div>
        </el-form-item>
      </div>
      <el-form-item  label="共计：" >
          <div><span class="red">{{goodform.kilometres}}</span>公里（{{goodform.arriveDepartFlag=='是'?'往返':'单程'}}）</div>
      </el-form-item>
      <hr>
      <div class="addressBox">
          <h4 class="title">
            <span><i class="fa fa-tags iconFont" aria-hidden="true"></i>货物信息</span>
          </h4>
      </div>
      <el-form-item  label="货物类型:" >
          <div style="width:80px">{{goodform.productTypeName}}</div>
      </el-form-item>
      <el-form-item  label="计量单位:" >
          <div style="width:80px">{{goodform.measuringUnit}}</div>
      </el-form-item>
      <el-form-item  label="重量(吨):">
          <div style="width:80px">{{goodform.dispatchWeightT?goodform.dispatchWeightT:'-'}}</div>
      </el-form-item>
      <el-form-item  label="数量(件):">
          <div style="width:80px">{{goodform.dispatchNumber?goodform.dispatchNumber:'-'}}</div>
      </el-form-item>
      <el-form-item  label="体积(方):">
          <div style="width:80px">{{goodform.dispatchVolumn?goodform.dispatchVolumn:'-'}}</div>
      </el-form-item>
      <el-form-item  label="货物备注:">
          <div style="width:80px">{{goodform.productRemark?goodform.productRemark:'-'}}</div>
      </el-form-item>
      <div style="padding:0 16px 16px 16px;" v-if="goodform.goodsList.length>0">
         <el-button type="primary"  size="mini" @click="exportHWFn"  :disabled="isDisable">导出</el-button>
        <el-table height="300px" size="mini" ref="tabref" :data="goodform.goodsList" style="width:100%" border center>
          <el-table-column type="index"  label="序号" width="60"></el-table-column>
           <el-table-column :show-overflow-tooltip="true"  prop="customerName"
            label="货权客户" min-width="180" :formatter="formatterRowEmpty"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="cargoBarcode" label="捆包号"
            min-width="180" :formatter="formatterRowEmpty"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="weight" label="重量(吨)"
            min-width="120" :formatter="formatterRowEmpty"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="number" label="数量(件)"
            min-width="120" :formatter="formatterRowEmpty"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="volumn" label="体积(方)"
            min-width="120" :formatter="formatterRowEmpty"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="productName" label="品名"
            min-width="120" :formatter="formatterRowEmpty"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="model" label="材质"
            min-width="120" :formatter="formatterRowEmpty"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="specification" label="规格"
            min-width="120" :formatter="formatterRowEmpty"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="cargoLocation" label="货位"
              min-width="120" :formatter="formatterRowEmpty"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="contractNumber" label="合同号"
            min-width="120" :formatter="formatterRowEmpty"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="agreementNumber" label="合约号"
            min-width="120" :formatter="formatterRowEmpty"></el-table-column>
        </el-table>
      </div>
      <hr>
      <div class="addressBox">
        <h4 class="title">
          <span><i class="fa fa-tags iconFont" aria-hidden="true"></i>车辆信息</span>
        </h4>
      </div>
      <el-form-item label="车   牌   号:"  label-width="72px">
        <div class="width1">{{goodform.plateNumber?goodform.plateNumber:'-'}}</div>
      </el-form-item>
      <el-form-item label="车辆归属:"  >
        <div class="width1">{{goodform.vehicleOwnershipName?goodform.vehicleOwnershipName:'-'}}</div>
      </el-form-item>
      <el-form-item label="车牌颜色:"  >
        <div class="width1">{{goodform.licensePlateColorName?goodform.licensePlateColorName:'-'}}</div>
      </el-form-item>
      <el-form-item label="能源类型:"  >
        <div class="width1">{{goodform.energyTypeName?goodform.energyTypeName:'-'}}</div>
      </el-form-item>
      <el-form-item label="车长:"  >
        <div class="width1">{{goodform.vehicleLength?goodform.vehicleLength:'-'}}</div>
      </el-form-item>
      <br>
      <el-form-item label="司机姓名:"  >
        <div class="width1">{{goodform.driverName?goodform.driverName:'-'}}</div>
      </el-form-item>
      <el-form-item label="司机电话:"  >
        <div class="width1">{{goodform.driverPhone?goodform.driverPhone:'-'}}</div>
      </el-form-item>
      <el-form-item label="司机归属:"  >
        <div class="width1">{{goodform.driverOwnershipName?goodform.driverOwnershipName:'-'}}</div>
      </el-form-item>
      <hr>
      <div class="addressBox">
        <h4 class="title">
          <span><i class="fa fa-tags iconFont" aria-hidden="true"></i>凭证信息</span>
        </h4>
      </div>
      <div style="">
        <h4 style="margin-left:16px;color:#0c46a2">装车</h4>
        <div style="padding-left:20px">
          <el-form-item label="装车量:"  >
            <div class="width1">{{goodform.truckload?goodform.truckload:'-'}}{{goodform.measuringUnit}}</div>
          </el-form-item>
          <el-form-item label="装车时间:"  >
            <div class="width1">{{goodform.actualLoadingTime|dateFormat}}</div>
          </el-form-item>
        </div>
        <div v-if="loadingImgs.length>0">
          <div class="imgBox">
            <el-image
              v-for="(item,index) in loadingImgs" :src="item.fileKeyUrl" :key="index"
              :preview-src-list="getSrcList(index,loadingImgs)">
            </el-image>
          </div>
          <div><span style="margin:0 46px 0 30px;"><span style="color:#999">上传人：</span>{{loadingImgs[0].createUser}}</span><span><span style="color:#999">上传时间：</span>{{loadingImgs[0].createTime|dateFormat}} </span></div>
        </div>
      </div>
      <div style="">
        <h4 style="margin-left:16px;color:#0c46a2">卸车</h4>
        <div style="padding-left:20px">
          <el-form-item label="卸车量:"  >
            <div class="width1">{{goodform.unloadings?goodform.unloadings:'-'}}{{goodform.measuringUnit}}</div>
          </el-form-item>
          <el-form-item label="卸车时间:"  >
            <div class="width1">{{goodform.actualUnloadingTime|dateFormat}}</div>
          </el-form-item>
        </div>
        <div v-if="unloadImgs.length>0">
          <div class="imgBox">
            <el-image
              v-for="(item,index) in unloadImgs" :src="item.fileKeyUrl" :key="index"
              :preview-src-list="getSrcList(index,unloadImgs)">
            </el-image>
          </div>
          <div><span style="margin:0 46px 0 30px;"><span style="color:#999">上传人：</span>{{unloadImgs[0].createUser}}</span><span><span style="color:#999">上传时间：</span>{{unloadImgs[0].createTime|dateFormat}} </span></div>
        </div>
      </div>
      <div style="">
        <h4 style="margin-left:16px;color:#0c46a2">签收</h4>
        <div style="padding-left:20px">
          <el-form-item label="签收状态:"  >
            <div class="width1">{{goodform.signedState||goodform.signedState==0?['正常签收','异常签收'][goodform.signedState]:'-'}}</div>
          </el-form-item>
          <el-form-item label="签收备注:"  >
            <div class="width1">{{goodform.signRemark?goodform.signRemark:'-'}}</div>
          </el-form-item>
          <el-form-item label="签收量:"  >
            <div class="width1">{{goodform.liquidatedAmount?goodform.liquidatedAmount:'-'}}{{goodform.measuringUnit}}</div>
          </el-form-item>
          <el-form-item label="签收人:"  >
            <div class="width1">{{goodform.actualSigningPerson?goodform.actualSigningPerson:'-'}}</div>
          </el-form-item>
          <el-form-item label="签收时间:"  >
            <div class="width1">{{goodform.actualSigningTime|dateFormat}}</div>
          </el-form-item>
        </div>
        <div v-if="SignImgs.length>0">
          <div class="imgBox">
            <el-image
              v-for="(item,index) in SignImgs" :src="item.fileKeyUrl" :key="index"
              :preview-src-list="getSrcList(index,SignImgs)" >
            </el-image>
          </div>
          <div><span style="margin:0 46px 0 30px;"><span style="color:#999">上传人：</span>{{SignImgs[0].createUser}}</span><span><span style="color:#999">上传时间：</span>{{SignImgs[0].createTime|dateFormat}} </span></div>
        </div>
      </div>
      <hr>
      <div class="addressBox" style="margin-top:20px">
        <h4 class="title">
          <span><i class="fa fa-tags iconFont" aria-hidden="true"></i>运输要求</span>
        </h4>
      </div>
      <el-form-item label="要求到达时间:">
        <div class="width1">{{goodform.arrivalTime|dateFormat}}</div>
      </el-form-item>
      <el-form-item label="回单要求:"  >
        <div class="width1">{{goodform.receiptRequest}}</div>
      </el-form-item>
      <br>
      <el-form-item label="提货到场时间:"  >
        <div style="width:350px" v-if="goodform.pickupTimeStart">{{goodform.pickupTimeStart|dateFormat}}-{{goodform.pickupTimeEnd|dateFormat}}</div>
        <div v-else style="width:350px">-</div>
      </el-form-item>
      <el-form-item label="提货紧急程度:"  >
        <div class="width1" v-if="goodform.urgencyFlag||goodform.urgencyFlag==0">{{['正常','紧急','加急'][goodform.urgencyFlag]}}</div>
        <div v-else>-</div>
      </el-form-item>
      <br>
      <el-form-item label="备注:" class="remark" prop="remark" label-width="60px">
        <div>{{goodform.remark}}</div>
      </el-form-item>
      <div class="addressBox">
        <h4 class="title">
          <span><i class="fa fa-tags iconFont" aria-hidden="true"></i>附件</span>
        </h4>
      </div>
      <div class="fujianBox">
        <el-button type="text" v-for="item in fujianList" @click="fujianClick(item)" :key="item.id">{{item.name}}</el-button>
      </div>
    </el-tab-pane>
    <el-tab-pane label="北斗定位" name="second" v-if="goodform.wayState==1||goodform.wayState==2">
      <mapreal :mapData="goodform" v-if="activeName=='second'"></mapreal>
    </el-tab-pane>
    <el-tab-pane label="北斗轨迹" name="second1" v-if="goodform.wayState>2">
      <maphistory :mapData="goodform" v-if="activeName=='second1'"></maphistory>
    </el-tab-pane>
    <el-tab-pane label="收入信息" name="third">
      <div class="addressBox" style="margin-top:20px">
        <h4 class="title">
          <span><i class="fa fa-tags iconFont" aria-hidden="true"></i>应收信息</span>
        </h4>
      </div>
      <el-form-item label="结算客户:"  >
        <div class="width2" style="width:320px">{{goodform.payee}}</div>
      </el-form-item>
      <el-table :data="[{}]"  ref="table"  bordersize="mini" class="tableBox" style="" max-height="500px"  center border>
       <el-table-column label="是否开票" min-width="120">
        <template >
          <div>
             {{goodform.makeTicketYn}}
          </div>
        </template>
      </el-table-column>
      <el-table-column label="是否一票制" min-width="120">
        <template >
          <div>
             {{goodform.ticketSystemYn}}
          </div>
        </template>
      </el-table-column>
      <el-table-column label="收入方式" min-width="120">
        <template >
          <div>
            {{[ "月结", "现结"][goodform.incomePattern]}}
          </div>
        </template>
      </el-table-column>

      <el-table-column label="收入计价" min-width="120">
        <template >
          <div>
            {{goodform.revenueValuationName}}
          </div>
        </template>
      </el-table-column>
      <el-table-column label="收入含税单价(元)" min-width="120">
        <template >
          <div>
             {{goodform.revenueValuation==1?'-':(goodform.incomeUnitPrice/100)|moneyFormatNew}}
          </div>
        </template>
      </el-table-column>
      <el-table-column label="结算量" min-width="120">
        <template >
          <div>
            <span v-if="goodform.liquidatedAmount">{{goodform.liquidatedAmount}}{{goodform.measuringUnit}}</span>
            <span v-else>-</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="收入金额(元)" min-width="120">
        <template >
          <div>
             {{(goodform.incomeAmount/100)|moneyFormatNew}}
          </div>
        </template>
      </el-table-column>
      <el-table-column label="收入附加费(元)" min-width="120">
        <template >
          <div>
             {{(goodform.revenueSurcharge/100)|moneyFormatNew}}
          </div>
        </template>
      </el-table-column>
      <el-table-column label="收入备注" min-width="120">
        <template >
          <div>
             {{goodform.incomeRemark?goodform.incomeRemark:'-'}}
          </div>
        </template>
      </el-table-column>
      <el-table-column label="收入含税总额(元)" min-width="120">
        <template >
          <div>
             {{(goodform.grossRevenue/100)|moneyFormatNew}}
          </div>
        </template>
      </el-table-column>
      <el-table-column label="收入税率" min-width="120">
        <template >
          <div>
             {{goodform.taxRate}}%
          </div>
        </template>
      </el-table-column>
      </el-table>
      <div class="addressBox" style="margin-top:20px">
        <h4 class="title">
          <span><i class="fa fa-tags iconFont" aria-hidden="true"></i>实收信息</span>
        </h4>
      </div>
      <el-table height="200px" size="mini" ref="tabref" :data="SSlist" style="width:100%" border center>
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column type="index"  label="序号" width="60"></el-table-column>
        <el-table-column prop="name"  label="收款凭证">
          <template slot-scope="scope">
            <div>
              <el-button type="text" size="mini"  @click="lookFN(scope.row)">查看</el-button>
            </div>
            </template>
        </el-table-column>
        <el-table-column prop="collectionAmount"  label="收款金额(元)"></el-table-column>
        <el-table-column prop="collectionTime" :formatter="dateTimeFormat" label="收款时间"></el-table-column>
        <el-table-column prop="createUser"  label="收款人"></el-table-column>
      </el-table>
      <div class="addressBox" style="margin-top:20px">
        <h4 class="title">
          <span><i class="fa fa-tags iconFont" aria-hidden="true"></i>开票信息</span>
        </h4>
      </div>
      <el-table height="200px" size="mini" ref="tabref" :data="SSFPlist" style="width:100%" border center>
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column type="index"  label="序号" width="60"></el-table-column>
        <el-table-column prop="name"  label="发票凭证">
          <template slot-scope="scope">
            <div>
              <el-button type="text" size="mini"  @click="lookFN1(scope.row)">查看</el-button>
            </div>
            </template>
        </el-table-column>
        <el-table-column prop="invoiceNo"  label="发票号"></el-table-column>
        <el-table-column prop="invoiceAmount"  label="开票金额(元)"></el-table-column>
        <el-table-column prop="invoiceTime" :formatter="dateTimeFormat" label="开票时间"></el-table-column>
        <el-table-column prop="createUser"  label="开票人"></el-table-column>
      </el-table>

    </el-tab-pane>
    <el-tab-pane label="运费信息" name="fourth">
      <div class="addressBox" style="margin-top:20px">
        <h4 class="title">
          <span><i class="fa fa-tags iconFont" aria-hidden="true"></i>应付信息</span>
        </h4>
      </div>
     <el-form-item label="收款方:"  >
        <div class="width2" style="width:320px">{{goodform.payer}}</div>
      </el-form-item>
      <el-form-item label="车队长身份证号:" label-width="120px"  v-if="goodform.collectionType==3">
        <div class="width2">{{goodform.payerTaxId}}</div>
      </el-form-item>
      <el-table :data="[{}]"  ref="table"  bordersize="mini" class="tableBox" style="" max-height="500px"  center border>
      <el-table-column label="支出方式" min-width="120">
        <template >
          <div>
             {{goodform.expenditurePatternName}}
          </div>
        </template>
      </el-table-column>
      <el-table-column label="运费计价" min-width="120">
        <template >
          <div>
             {{goodform.freightPricingTypeName}}
          </div>
        </template>
      </el-table-column>
      <el-table-column label="运费单价(元)" min-width="120">
        <template >
          <div>
            <span v-if="goodform.freightPricingType!=1"  >{{(goodform.freightUnitPrice/100)|moneyFormatNew}}</span>
            <span v-else>-</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="结算量" min-width="120">
        <template >
          <div>
            <span v-if="goodform.liquidatedAmount">{{goodform.liquidatedAmount}}{{goodform.measuringUnit}}</span>
            <span v-else>-</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="运费金额(元)" min-width="120">
        <template >
          <div>
             {{(goodform.freightAmount/100)|moneyFormatNew}}
          </div>
        </template>
      </el-table-column>
      <el-table-column label="支出附加费(元)" min-width="120">
        <template >
          <div>
             {{(goodform.disburseSurcharge/100)|moneyFormatNew}}
          </div>
        </template>
      </el-table-column>
       <el-table-column label="支出备注" min-width="120">
        <template >
          <div>
             {{goodform.freightRemark?goodform.freightRemark:'-'}}
          </div>
        </template>
      </el-table-column>
      <el-table-column label="运费含税总额(元)" min-width="120">
        <template >
          <div>
             {{(goodform.freightAmountTotal/100)|moneyFormatNew}}
          </div>
        </template>
      </el-table-column>
      <el-table-column label="服务费率%" min-width="120">
        <template >
          <div>
             {{goodform.serviceRate}}
          </div>
        </template>
      </el-table-column>
      <el-table-column label="服务费(元)" min-width="120">
        <template >
          <div>
             {{(goodform.serviceCharge/100)|moneyFormatNew}}
          </div>
        </template>
      </el-table-column>
      <el-table-column label="支出含税总额(元)" min-width="120">
        <template >
          <div>
            {{(goodform.freightTaxTotal/100)|moneyFormatNew}}
          </div>
        </template>
      </el-table-column>
      <el-table-column label="运费税率" min-width="120">
        <template >
          <div>
             {{goodform.freightTaxRate}}
          </div>
        </template>
      </el-table-column>
      </el-table>
      <div class="addressBox" style="margin-top:20px">
        <h4 class="title">
          <span><i class="fa fa-tags iconFont" aria-hidden="true"></i>实付信息</span>
        </h4>
      </div>
      <el-table height="200px" size="mini" ref="tabref" :data="SFlist" style="width:100%" border center>
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column type="index"  label="序号" width="60"></el-table-column>
        <el-table-column prop="name"  label="付款凭证">
          <template slot-scope="scope">
            <div>
              <el-button type="text" size="mini"  @click="YFlookFN(scope.row)">查看</el-button>
            </div>
            </template>
        </el-table-column>
        <el-table-column prop="collectionAmount"  :formatter="formatterRowEmpty" label="付款金额(元)"></el-table-column>
        <el-table-column prop="collectionTime" :formatter="dateTimeFormat" label="付款时间"></el-table-column>
        <el-table-column prop="createUser"  label="付款人"></el-table-column>
      </el-table>
       <div class="addressBox" style="margin-top:20px">
        <h4 class="title">
          <span><i class="fa fa-tags iconFont" aria-hidden="true"></i>开票信息</span>
        </h4>
      </div>
      <el-table height="200px" size="mini" ref="tabref" :data="SFFPlist" style="width:100%" border center>
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column type="index"  label="序号" width="60"></el-table-column>
        <el-table-column prop="name"  label="发票凭证">
          <template slot-scope="scope">
            <div>
              <el-button type="text" size="mini"  @click="YFlookFN1(scope.row)">查看</el-button>
            </div>
            </template>
        </el-table-column>
        <el-table-column prop="invoiceNo"  label="发票号"></el-table-column>
        <el-table-column prop="invoiceAmount" :formatter="formatterRowEmpty"  label="开票金额(元)"></el-table-column>
        <el-table-column prop="invoiceTime" :formatter="dateTimeFormat" label="开票时间"></el-table-column>
        <el-table-column prop="createUser"  label="开票人"></el-table-column>
      </el-table>
    </el-tab-pane>
    <el-tab-pane label="操作日志" name="five">
      <el-table  size="mini" ref="tabref" :data="logList" style="width:100%" border center>
        <el-table-column type="index"  label="序号" width="60"></el-table-column>
        <el-table-column  prop="content" label="操作事件" min-width="180"></el-table-column>
        <el-table-column  prop="remark" label="备注" min-width="180"></el-table-column>
        <el-table-column  prop="createUser" label="操作人"  min-width="180"></el-table-column>
        <el-table-column  prop="createTime"  :formatter="dateTimeFormat" label="操作时间" min-width="180"></el-table-column>
      </el-table>
      <div class="addressBox" style="margin-top:20px">
        <h4 class="title">
          <span><i class="fa fa-tags iconFont" aria-hidden="true"></i>调价记录</span>
        </h4>
      </div>
      <el-table height="400px" size="mini" ref="tabref" :data="jiluList" style="width:100%"  border center>
        <el-table-column type="index"  label="序号" width="60"></el-table-column>
        <el-table-column prop="modifyItem" min-width="130" label="修改项"></el-table-column>
        <el-table-column prop="modifyContent" min-width="200"  label="修改后"></el-table-column>
        <el-table-column prop="createUser" min-width="130" label="修改人"></el-table-column>
        <el-table-column prop="createTime" min-width="170" :formatter="dateTimeFormat" label="创建时间"></el-table-column>
      </el-table>
    </el-tab-pane>
  </el-tabs>
</el-form>

<el-dialog  title="查看图片" :close-on-click-modal="false" :close-on-press-escape="false"   :visible.sync="lookImgFlag"
  append-to-body width="800px" center>
  <div style="text-align: right;">
    <div id="printMe"  ref="print">
      <el-image style="width: 100%;" :src="imgUrl" fit="contain"></el-image>
    </div>
  </div>
</el-dialog>
<el-image-viewer v-if="dialogImg"  :on-close="closeViewer"   :url-list="lookimgList" />
<el-dialog  title="凭证" :close-on-click-modal="false" :close-on-press-escape="false"   :visible.sync="fppzFlag" width="500px" center>
    <div class="fujianBox">
        <el-button type="text" v-for="item in fppzList" @click="fujianClick(item)" :key="item.id">{{item.name}}</el-button>
    </div>
</el-dialog>
</div>
</template>

<script>
import { getWaynfo, getSettlementRecordForWay, getInvoiceRecordForWay, getFileShow, queryWayImg, queryInvoiceFile,
  queryUpstreamSettlementFile, findPriceAdjustmentRecord } from '@/api/newTMS'
import { dateTimeFormat, formatterRowEmpty, viewPdf } from '@/utils/util'
import ElImageViewer from 'element-ui/packages/image/src/image-viewer'
import maphistory from '@/views/newTMS/publicFiles/wayManage/maphistory.vue'
import mapreal from '@/views/newTMS/publicFiles/wayManage/mapreal.vue'
import { exportExcel } from '@/utils/fileDownXlsx.js'
export default {
  components: { ElImageViewer, maphistory, mapreal },
  data () {
    let id = this.$route.query.id
    return {
      dateTimeFormat: dateTimeFormat,
      formatterRowEmpty: formatterRowEmpty,
      id: id,
      goodform: { goodsList: [] },
      fujianList: [],
      lookImgFlag: false,
      imgUrl: '',
      logList: [],
      loadingImgs: [],
      unloadImgs: [],
      SignImgs: [],
      activeName: 'first',
      SSlist: [],
      SSFPlist: [],
      SFlist: [],
      SFFPlist: [],
      lookimgList: [],
      dialogImg: false,
      fppzFlag: false,
      fppzList: [],
      jiluList: [],
      isDisable: false
    }
  },
  mounted: function () { // 在更新DOM之前 调用此钩子函数 应用：可以获取原始的DOM
    getWaynfo({ wayBusinessId: this.id }).then(res => {
      this.goodform = res.tWay

      this.logList = res.serviceLogList
      this.$set(this.goodform, 'goodsList', res.goodslist)
      this.fujianList = []
      res.wayAttachmentsList.forEach(item => {
        var filename = item.url.split('/').pop()
        this.fujianList.push({
          name: filename,
          url: item.fileKeyUrl
        })
      })
      for (var key in res.tWayBusiness) {
        if (key != 'id') {
          this.$set(this.goodform, key, res.tWayBusiness[key])
        }
      }
      if (this.goodform.onlineAddPushFlag == 1 || this.goodform.onlineAddPushFlag == 4) { // 推网货走的逻辑
        queryWayImg({ wayNo: this.goodform.wayNo }).then(res => {
          res.loadingImgs.forEach(item => {
            this.loadingImgs.push({ fileKeyUrl: item.fileUrlOSS, id: item.id, createUser: item.createUserName, createTime: item.createTime })
          })
          res.unloadImgs.forEach(item => {
            this.unloadImgs.push({ fileKeyUrl: item.fileUrlOSS, id: item.id, createUser: item.createUserName, createTime: item.createTime })
          })
        })
        if (this.goodform.yfPaymentAmount) {
          this.SFlist = [{
            collectionAmount: this.goodform.yfPaymentAmount / 100,
            collectionTime: this.goodform.yfPaymentTime,
            createUser: this.goodform.yfPaymentUserName

          }]
        }
        if (this.goodform.yfInvoiceOn) {
          this.SFFPlist = [{
            invoiceNo: this.goodform.yfInvoiceOn,
            invoiceAmount: this.goodform.yfInvoiceAmount / 100,
            invoiceTime: this.goodform.yfInvoiceTime,
            createUser: this.goodform.yfInvoiceUserName

          }]
        }
      } else {
        this.loadingImgs = res.wayLoadAttachmentsList
        this.unloadImgs = res.wayUnloadAttachmentsList
        this.SignImgs = res.waySignAttachmentsList
        getSettlementRecordForWay({ wayBusinessId: this.id, ysYfFlag: 1 }).then(res => {
          this.SFlist = res
        })
        getInvoiceRecordForWay({ wayBusinessId: this.id, ysYfFlag: 1 }).then(res => {
          this.SFFPlist = res
        })
      }
      findPriceAdjustmentRecord({ wayId: this.goodform.wayId }).then(res => {
        this.jiluList = res
      }).catch(error => {
        this.$message({
          showClose: true,
          message: error.message,
          type: 'error',
          onClose () {
          }
        })
      })
    })
    getSettlementRecordForWay({ wayBusinessId: this.id, ysYfFlag: 0 }).then(res => {
      this.SSlist = res
    })
    getInvoiceRecordForWay({ wayBusinessId: this.id, ysYfFlag: 0 }).then(res => {
      this.SSFPlist = res
    })
  },
  methods: {
  // 货物导出
    async exportHWFn () {
      this.isDisable = true
      await exportExcel(
        this.global.tmsPlus + '/way/exportWayGoods',
        { wayId: this.goodform.wayId },
        '货物列表'
      )
      this.isDisable = false
    },
    YFlookFN (row) {
      if (this.goodform.onlineAddPushFlag == 1 || this.goodform.onlineAddPushFlag == 4) {
        queryUpstreamSettlementFile({ onlineOrderNo: this.goodform.onlineOrderNo }).then(res => {
          viewPdf(res)
        }).catch(error => {
          this.$set(this.goodform, 'serviceRate', null)
          this.$message({
            showClose: true,
            message: error.message,
            type: 'error',
            onClose () {
            }
          })
        })
      } else {
        this.lookFN(row)
      }
    },
    YFlookFN1 (row) {
      this.fppzList = []
      if (this.goodform.onlineAddPushFlag == 1 || this.goodform.onlineAddPushFlag == 4) {
        queryInvoiceFile({ onlineOrderNo: this.goodform.onlineOrderNo }).then(res => {
          if (res.invoiceFiles.length > 1) {
            res.invoiceFiles.forEach(item => {
              var filename = item.fileUrl.split('/').pop()
              this.fppzList.push({
                name: filename,
                url: item.fileUrlOss
              })
            })
            this.fppzFlag = true
          } else {
            window.open(res.invoiceFiles[0].fileUrlOss)
          }
        }).catch(error => {
          this.$set(this.goodform, 'serviceRate', null)
          this.$message({
            showClose: true,
            message: error.message,
            type: 'error',
            onClose () {
            }
          })
        })
      } else {
        this.lookFN1(row)
      }
    },
    lookFN (row) {
      getFileShow({ businessId: row.id, businessType: 'settlementRecordMaster' }).then(res => {
        this.lookimgList = [res[0].fileKeyUrl]
        this.dialogImg = true
      })
    },
    closeViewer () {
      this.dialogImg = false
    },
    lookFN1 (row) {
      if (row.applyId) {
        this.fppzList = []
        getFileShow({ businessId: row.applyId, businessType: 'invoiceRecordApplyQr' }).then(res => {
          if (res.length > 0) {
            var filename = res[0].url.split('/').pop()
            this.fppzList.push({
              name: filename,
              url: res[0].fileKeyUrl
            })
          }
          getFileShow({ businessId: row.applyId, businessType: 'invoiceRecordApply' }).then(res => {
            res.forEach(item => {
              var filename = item.url.split('/').pop()
              this.fppzList.push({
                name: filename,
                url: item.fileKeyUrl
              })
            })
            this.fppzFlag = true
          })
        })
      } else {
        getFileShow({ businessId: row.id, businessType: 'invoiceRecordMaster' }).then(res => {
          if (res.length > 0) {
            if (this.isImage(res[0].url)) {
              this.lookimgList = [res[0].fileKeyUrl]
              this.dialogImg = true
            } else {
              window.open(res[0].fileKeyUrl)
            }
          } else {
            this.$alert('暂无发票凭证', '系统提示')
          }
        })
      }
    },
    fujianClick (row) {
      if (this.isImage(row.name)) {
        this.lookImgFlag = true
        this.imgUrl = row.url
      } else {
        window.open(row.url)
      }
    },
    // 点击凭证放大
    getSrcList (index, arr) {
      let imgArr = arr.slice(index).concat(arr.slice(0, index))
      let urls = []
      imgArr.forEach(item => {
        urls.push(item.fileKeyUrl)
      })
      return urls
    },
    isImage (filename) {
      const extension = filename.split('.').pop().toLowerCase()
      const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp', 'svg']
      return imageExtensions.includes(extension)
    },

    back () {
      console.log(111)
      this.$router.go(-1)// 返回上一层
    }
  }

}
</script>

<style scoped lang='less'>
  .width1{
    width:150px
  }
  .width2{
    width: 260px;
  }
  .dizhiIcon{
  font-size: 18px;
  margin-right: 4px;
}
.fujianBox{
  margin-left: 20px;
  display: flex;
  flex-direction: column;
  /deep/.el-button--text{
    text-align: left;
    margin-left: 0;
    margin-bottom: 10px;
  }
}
.imgBox{
  /deep/.el-image{
    width: 180px;
    height: 130px;
    margin: 30px;
  }
}
/deep/.el-form-item{
  padding-left:16px;
}
/deep/.el-form-item__label{
  color: #999;
}
</style>
